import { TemplateState } from './template.state';
import { templateAdapter } from './template.entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as fromAction from './template.action';
import { ClassroomCourseFilter } from '@modules/course/classroom/models';

const initialState: TemplateState = templateAdapter.getInitialState({
  selectedId: null,
  classrooms: [],
  classroomFilter: new ClassroomCourseFilter(),
  error: null,
  totalCount: 0,
  filter: null,
});

const _templateReducer = createReducer(
  initialState,
  on(fromAction.AddTemplates, (state, { templates }) => {
    return templateAdapter.setAll(templates, state);
  }),
  on(fromAction.AddTemplate, (state, { template }) => {
    return templateAdapter.upsertOne(template, state);
  }),
  on(fromAction.AddClassroomFilter, (state, { classroomFilter }) => {
    return { ...state, classroomFilter };
  }),
  on(fromAction.ResetClassroomFilter, (state) => {
    return{...state, classroomFilter: initialState.classroomFilter}
  }),
  on(fromAction.AddClassroomCourses, (state, { classrooms }) => {
    return { ...state, classrooms };
  }),
  on(fromAction.RemoveClassroomCourses, (state) => {
    return { ...state, classrooms: [] };
  }),
  on(fromAction.AddError, (state, { error }) => {
    return { ...state, error: error };
  })
);

export function templateReducer(state: TemplateState = initialState, action: Action): TemplateState {
  return _templateReducer(state, action);
}
